namespace $ {
	$mol_style_define( $mol_frame , {
		border: 'none',
		flex: 'auto',
	} )
}
